import React, { useEffect, useState } from "react";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { StyledH3 } from "../../../common/components/Title/styles";
import { StatusGridContainer } from "./CaseStatusGrid";
import { Grid } from "@mui/material";
import { getAlignerMaterial } from "../../../api/alignerMaterialsApi";
import { getService } from "../../../api/serviceApi";
import UpdateAlignerMaterialDialog from "./UpdateAlignerMaterialDialog";
import { StyledButton } from "../../../common/components/Button";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import { Box } from "@mui/system";
import UpdateCaseTermsOfPaymentDialog from "./UpdateCaseTermsOfPaymentDialog";
import ReportGenerator from "./ReportGenerator";
import AddPaymentTransactionManualDialog from "./AddPaymentTransactionManualDialog";
import AddPaymentTransactionThruEmailDialog from "./AddPaymentTransactionThruEmailDialog";
import isCaseTerminated from "../../../common/helpers/isCaseTerminated";
import AddPaymentTransactionThruLinkDialog from "./AddPaymentTransactionThruLinkDialog";
import { isCaseProgressDone } from "../../../common/helpers/isCaseProgressDone";
import { paymentOptions } from "../../../common/Constants";
import CreateSubscriptionDialog from "./CreateSubscriptionDialog";
import UpdateCaseTotalPriceDialog from "./UpdateCaseTotalPriceDialog";
import ConfirmCancelPayment from "./ConfirmCancelPayment";

const PaymentProgressTable = ({
  caseDetails,
  paymentTransactionRows,
  getPaymentTransactions,
  getCaseData,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const [alignerMaterial, setAlignerMaterial] = useState({});
  const [openUpdatePaymentInformation, setOpenUpdatePaymentInformation] =
    useState(false);
  const [openUpdateCaseTermsOfPayment, setOpenUpdateCaseTermsOfPayment] =
    useState(false);

  const [openAddPaymentTransactionManual, setOpenAddPaymentTransactionManual] =
    useState(false);
  const [openCancelPayment, setOpenCancelPayment] = useState(false);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [openUpdateCaseTotalPrice, setOpenUpdateCaseTotalPrice] =
    useState(false);

  const [
    openAddPaymentTransactionThruEmail,
    setOpenAddPaymentTransactionThruEmail,
  ] = useState(false);

  const [
    openAddPaymentTransactionThruLink,
    setOpenAddPaymentTransactionThruLink,
  ] = useState(false);

  const [openCreateSubcriptionPlan, setOpenCreateSubcriptionPlan] =
    useState(false);

  const [service, setService] = useState({});

  const checkPaymentOptions = (paymentTransactionName) => {
    for (const paymentOption of paymentOptions) {
      if (paymentOption.paymentTransactionName === paymentTransactionName) {
        return paymentOption.id;
      }
    }
  };

  const isDownpaymentPaid = () => {
    console.log(caseDetails);
    if (caseDetails?.termsOfPayment1?.name.toLowerCase() === "downpayment") {
      for (const paymentTransaction of paymentTransactionRows) {
        if (
          checkPaymentOptions(paymentTransaction.name) ===
            caseDetails.termsOfPayment1.paymentSchedules[0].step &&
          paymentTransaction.amount ===
            caseDetails.termsOfPayment1.paymentSchedules[0].amountOrNumberOfSets
        ) {
          return true;
        }
      }
      return false;
    }
    return false;
  };

  const handleCloseUpdatePaymentInformation = () => {
    setOpenUpdatePaymentInformation(false);
  };

  const handleCloseAddPaymentTransactionManual = () => {
    setOpenAddPaymentTransactionManual(false);
  };

  const handleCloseAddPaymentTransactionThruEmail = () => {
    setOpenAddPaymentTransactionThruEmail(false);
  };

  const handleCloseAddPaymentTransactionThruLink = () => {
    setOpenAddPaymentTransactionThruLink(false);
  };

  const handleCloseUpdateCaseTermsOfPayment = () => {
    setOpenUpdateCaseTermsOfPayment(false);
  };

  const handleOpenCancelSubscriptionDialog = () => {
    setOpenCancelPayment(true);
  }
  const handleOpenCreateSubscriptionDialog = () => {
    if (
      caseDetails.termsOfPayment2 == null &&
      caseDetails.noOfSetsUpper !== 0 &&
      caseDetails.noOfSetsLower !== 0 &&
      caseDetails.treatmentTypeTotalAmount === 0
    ) {
      handleOpenAlert();
      handleSetAlertMessage(
        "The case has no specified total amount, there is no current terms of payment after design, and you have already existing sets under the Fabrication and Shipment tab."
      );
    } else if (caseDetails.treatmentTypeTotalAmount === 0) {
      handleOpenAlert();
      handleSetAlertMessage("The case has no specified total amount.");
    } else if (caseDetails.termsOfPayment2 == null) {
      handleOpenAlert();
      handleSetAlertMessage("Choose first your terms of payment after design.");
    } else if (
      caseDetails.noOfSetsUpper !== 0 &&
      caseDetails.noOfSetsLower !== 0
    ) {
      handleOpenAlert();
      handleSetAlertMessage(
        "You have already an existing sets under the Fabrication and Shipment tab"
      );
    } else if (
      caseDetails.paymentTransactions?.some((x) => x.name === "Set Payment")
    ) {
      handleOpenAlert();
      handleSetAlertMessage("The case has an existing subscription");
    } else {
      setOpenCreateSubcriptionPlan(true);
    }
  };

  const handleOpenEditCaseTotalPrice = () => {
    if (caseDetails.noOfSetsLower !== 0 && caseDetails.noOfSetsUpper !== 0) {
      handleOpenAlert();
      handleSetAlertMessage("The case has existing sets.");
      return;
    }
    if (
      caseDetails.paymentTransactions?.some((x) => x.name === "Set Payment")
    ) {
      handleOpenAlert();
      handleSetAlertMessage("The case has an existing subscription");
      return;
    }

    setOpenUpdateCaseTotalPrice(true);
  };

  const getPaymentProgressInfo = async () => {
    const alignerMaterialResponse = await getAlignerMaterial(
      caseDetails.alignerMaterialId
    );
    const serviceResponse = await getService(caseDetails.serviceId);
    setAlignerMaterial(alignerMaterialResponse);
    setService(serviceResponse);
  };

  useEffect(() => {
    getPaymentTransactions();
    getPaymentProgressInfo();

    const totalAmount = paymentTransactionRows.reduce(
      (a, b) => a + b.amount,
      0
    );
    setTotalAmountPaid(totalAmount);
  }, []);

  const handleSetAlignerMaterial = (response) => {
    setAlignerMaterial(response);
  };
  const columns = [
    { field: "name", headerName: "Payment", flex: 2 },
    { field: "transactionNo", headerName: "Transaction No.", flex: 2 },
    {
      field: "date",
      headerName: "Date",
      flex: 2,
      valueFormatter: (params) =>
        params?.value !== null ? normalizeDateTime(params?.value) : "",
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 2,
      type: "number",
      headerAlign: "right",
      align: "right",
      valueFormatter: (params) =>
        params?.value &&
        params?.value.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
  ];
  return (
    <div>
      <div style={{ display: "flex" }}>
        <StyledH3 theme="lightpurple">Payment Information</StyledH3>
      </div>

      <StatusGridContainer>
        <Grid
          container
          spacing={0}
          style={{
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
            height: "55px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item md={4}>
            Consultation
          </Grid>
          <Grid item md={8} style={{ fontWeight: 600 }}>
            {service?.name}
          </Grid>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            backgroundColor: "#F0F0F0",
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
            height: "55px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item md={4}>
            Terms of Payment Before Design
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            {caseDetails.termsOfPayment1 != null
              ? caseDetails.termsOfPayment1?.name
              : ""}{" "}
            {caseDetails.termsOfPayment1?.modeOfPayment != null
              ? " (Payment via " +
                caseDetails.termsOfPayment1?.modeOfPayment?.name +
                ")"
              : ""}
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            {caseDetails.status !== "Case complete" &&
            !isCaseTerminated(caseDetails) ? (
              <StyledButton
                sx={{ height: "35px" }}
                theme="green"
                onClick={() => setOpenUpdateCaseTermsOfPayment(true)}
              >
                Edit
              </StyledButton>
            ) : null}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
            height: "55px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item md={4}>
            Terms of Payment After Design
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            {caseDetails.termsOfPayment2 != null
              ? caseDetails.termsOfPayment2?.name
              : ""}{" "}
            {caseDetails.termsOfPayment2?.modeOfPayment != null
              ? " (Payment via " +
                caseDetails.termsOfPayment2?.modeOfPayment?.name +
                ")"
              : ""}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{
            backgroundColor: "#F0F0F0",
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
            height: "55px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item md={4}>
            Aligner Material
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            {alignerMaterial?.name}
          </Grid>

          <Grid item md={3} style={{ fontWeight: 600 }}>
            {caseDetails.status !== "Case complete" &&
            !isCaseTerminated(caseDetails) ? (
              <StyledButton
                sx={{ height: "35px" }}
                theme="green"
                onClick={() => setOpenUpdatePaymentInformation(true)}
              >
                Edit
              </StyledButton>
            ) : null}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
            height: "55px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item md={4}>
            Case Total Price
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            {caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Grid>

          <Grid item md={3} style={{ fontWeight: 600 }}>
            {!isCaseTerminated(caseDetails) ? (
              <StyledButton
                sx={{ height: "35px" }}
                theme="green"
                onClick={() => handleOpenEditCaseTotalPrice()}
              >
                Edit
              </StyledButton>
            ) : null}
          </Grid>
        </Grid>
      </StatusGridContainer>

      <StyledH3 theme="lightpurple" style={{ marginTop: "20px" }}>
        Payment Transactions
      </StyledH3>
      {!isCaseTerminated(caseDetails) && (
        <div>
          <StyledButton
            theme="green"
            onClick={() => setOpenAddPaymentTransactionManual(true)}
            style={{ marginRight: "10px", marginBottom: "5px" }}
          >
            Add Manual Payment
          </StyledButton>
          <StyledButton
            theme="green"
            marginRight="10px"
            style={{ marginBottom: "5px" }}
            onClick={() => setOpenAddPaymentTransactionThruEmail(true)}
          >
            Send Payment Email
          </StyledButton>

          <StyledButton
            theme="green"
            marginRight="10px"
            style={{ marginBottom: "5px" }}
            onClick={() => setOpenAddPaymentTransactionThruLink(true)}
          >
            Generate Payment Link
          </StyledButton>
          <StyledButton
            theme="green"
            marginRight="10px"
            style={{ marginBottom: "5px" }}
            onClick={() => handleOpenCreateSubscriptionDialog()}
          >
            Create Subscription Plan
          </StyledButton>
          <ReportGenerator
            getCaseData={getCaseData}
            caseDetails={caseDetails}
            paymentTransactions={paymentTransactionRows}
            totalPrice={caseDetails.treatmentTypeTotalAmount}
            totalAmountPaid={paymentTransactionRows.reduce(
              (a, b) => a + b.amount,
              0
            )}
            isDownpaymentPaid={isDownpaymentPaid()}
          />
          <StyledButton
            theme="green"
            marginRight="10px"
            style={{ marginBottom: "5px", backgroundColor: "red"  }}
            onClick={() => handleOpenCancelSubscriptionDialog()}
          >
            Cancel Payment Plan
          </StyledButton>
        </div>
      )}

      <StyledDataGrid
        autoHeight
        rows={paymentTransactionRows}
        columns={columns}
        hideFooterPagination
        hideFooter
      />

      {paymentTransactionRows && paymentTransactionRows.length > 0 && (
        <Box
          sx={{
            marginLeft: "auto",
            width: "max-content",
            fontSize: "14px",
            padding: "10px",
          }}
        >
          Total:
          <Box component="span" sx={{ marginLeft: 1, fontWeight: 600 }}>
            {paymentTransactionRows
              .reduce((a, b) => a + b.amount, 0)
              .toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </Box>
        </Box>
      )}

      {caseDetails.treatmentTypeTotalAmount != null && (
        <Box
          sx={{
            marginLeft: "auto",
            width: "max-content",
            fontSize: "14px",
            padding: "10px",
          }}
        >
          Case Total Price:
          <Box component="span" sx={{ marginLeft: 1, fontWeight: 600 }}>
            {caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
      )}
      <UpdateAlignerMaterialDialog
        openUpdatePaymentInformation={openUpdatePaymentInformation}
        handleCloseUpdatePaymentInformation={
          handleCloseUpdatePaymentInformation
        }
        caseId={caseDetails.id}
        currentAlignerMaterial={alignerMaterial}
        handleSetAlignerMaterial={handleSetAlignerMaterial}
        getCaseData={getCaseData}
      />
      <UpdateCaseTermsOfPaymentDialog
        openUpdateCaseTermsOfPayment={openUpdateCaseTermsOfPayment}
        handleCloseUpdateCaseTermsOfPayment={
          handleCloseUpdateCaseTermsOfPayment
        }
        termsOfPayment1={caseDetails.termsOfPayment1}
        caseId={caseDetails.id}
        getCaseData={getCaseData}
      />
      <AddPaymentTransactionManualDialog
        openAddPaymentTransaction={openAddPaymentTransactionManual}
        handleCloseAddPaymentTransaction={
          handleCloseAddPaymentTransactionManual
        }
        caseDetails={caseDetails}
        getPaymentTransactions={getPaymentTransactions}
      />
      <ConfirmCancelPayment
        open={openCancelPayment}
        onClose={() => setOpenCancelPayment(false)}
        caseDetails={caseDetails}
      />
      <AddPaymentTransactionThruEmailDialog
        openAddPaymentTransaction={openAddPaymentTransactionThruEmail}
        handleCloseAddPaymentTransaction={
          handleCloseAddPaymentTransactionThruEmail
        }
        caseDetails={caseDetails}
        getPaymentTransactions={getPaymentTransactions}
      />

      <AddPaymentTransactionThruLinkDialog
        openAddPaymentTransaction={openAddPaymentTransactionThruLink}
        handleCloseAddPaymentTransaction={
          handleCloseAddPaymentTransactionThruLink
        }
        caseDetails={caseDetails}
        getPaymentTransactions={getPaymentTransactions}
      />
      <CreateSubscriptionDialog
        open={openCreateSubcriptionPlan}
        onClose={() => setOpenCreateSubcriptionPlan(false)}
        caseDetails={caseDetails}
      />
      <UpdateCaseTotalPriceDialog
        open={openUpdateCaseTotalPrice}
        onClose={() => setOpenUpdateCaseTotalPrice(false)}
        caseId={caseDetails.id}
        getCaseData={getCaseData}
      />
    </div>
  );
};

export default PaymentProgressTable;
